import request from '@/utils/request'

// 删除用户记录
export function removeProfile(data) {
  return request({
      url: '/alfmeier/removeProfile',
      method: 'post',
      data,
  })
}
// 获取单个用户记录
export function findProfile(params) {
  return request({
      url: '/alfmeier/findProfile',
      method: 'get',
      params,
  })
}
// 获取用户记录列表
export function findProfileList(params) {
  return request({
      url: '/alfmeier/findProfileList',
      method: 'get',
      params,
  })
}
// 导出用户记录
export function exportProfile(params) {
  return request({
      url: '/alfmeier/exportProfile',
      method: 'get',
      params,
  })
}

// 创建评价
export function createRank(data) {
  return request({
      url: '/alfmeier/createRank',
      method: 'post',
      data,
  })
}
// 修改评价
export function updateRank(data) {
  return request({
      url: '/alfmeier/updateRank',
      method: 'post',
      data,
  })
}
// 删除评价
export function removeRank(data) {
  return request({
      url: '/alfmeier/removeRank',
      method: 'post',
      data,
  })
}
// 获取单个评价
export function findRank(params) {
  return request({
      url: '/alfmeier/findRank',
      method: 'get',
      params,
  })
}
// 获取评价列表
export function findRankList(params) {
  return request({
      url: '/alfmeier/findRankList',
      method: 'get',
      params,
  })
}
// 导出评价
export function exportRank(params) {
  return request({
      url: '/alfmeier/exportRank',
      method: 'get',
      params,
  })
}
// 删除评价记录
export function removeRankRecord(data) {
  return request({
      url: '/alfmeier/removeRankRecord',
      method: 'post',
      data,
  })
}
// 获取单个评价记录
export function findRankRecord(params) {
  return request({
      url: '/alfmeier/findRankRecord',
      method: 'get',
      params,
  })
}
// 获取评价记录列表
export function findRankRecordList(params) {
  return request({
      url: '/alfmeier/findRankRecordList',
      method: 'get',
      params,
  })
}
// 导出评价记录
export function exportRankRecord(params) {
  return request({
      url: '/alfmeier/exportRankRecord',
      method: 'get',
      params,
  })
}

// 创建支付
export function createPayment(data) {
  return request({
      url: '/alfmeier/createPayment',
      method: 'post',
      data,
  })
}
// 修改支付
export function updatePayment(data) {
  return request({
      url: '/alfmeier/updatePayment',
      method: 'post',
      data,
  })
}
// 删除支付
export function removePayment(data) {
  return request({
      url: '/alfmeier/removePayment',
      method: 'post',
      data,
  })
}
// 获取单个支付
export function findPayment(params) {
  return request({
      url: '/alfmeier/findPayment',
      method: 'get',
      params,
  })
}
// 获取支付列表
export function findPaymentList(params) {
  return request({
      url: '/alfmeier/findPaymentList',
      method: 'get',
      params,
  })
}
// 导出支付
export function exportPayment(params) {
  return request({
      url: '/alfmeier/exportPayment',
      method: 'get',
      params,
  })
}
// 删除支付记录
export function removePaymentRecord(data) {
  return request({
      url: '/alfmeier/removePaymentRecord',
      method: 'post',
      data,
  })
}
// 获取单个支付记录
export function findPaymentRecord(params) {
  return request({
      url: '/alfmeier/findPaymentRecord',
      method: 'get',
      params,
  })
}
// 获取支付记录列表
export function findPaymentRecordList(params) {
  return request({
      url: '/alfmeier/findPaymentRecordList',
      method: 'get',
      params,
  })
}
// 导出支付记录
export function exportPaymentRecord(params) {
  return request({
      url: '/alfmeier/exportPaymentRecord',
      method: 'get',
      params,
  })
}

// 创建问卷
export function createQuest(data) {
  return request({
      url: '/alfmeier/createQuest',
      method: 'post',
      data,
  })
}
// 修改问卷
export function updateQuest(data) {
  return request({
      url: '/alfmeier/updateQuest',
      method: 'post',
      data,
  })
}
// 删除问卷
export function removeQuest(data) {
  return request({
      url: '/alfmeier/removeQuest',
      method: 'post',
      data,
  })
}
// 获取单个问卷
export function findQuest(params) {
  return request({
      url: '/alfmeier/findQuest',
      method: 'get',
      params,
  })
}
// 获取问卷列表
export function findQuestList(params) {
  return request({
      url: '/alfmeier/findQuestList',
      method: 'get',
      params,
  })
}
// 导出问卷
export function exportQuest(params) {
  return request({
      url: '/alfmeier/exportQuest',
      method: 'get',
      params,
  })
}
// 删除问卷记录
export function removeQuestRecord(data) {
  return request({
      url: '/alfmeier/removeQuestRecord',
      method: 'post',
      data,
  })
}
// 获取单个问卷记录
export function findQuestRecord(params) {
  return request({
      url: '/alfmeier/findQuestRecord',
      method: 'get',
      params,
  })
}
// 获取问卷记录列表
export function findQuestRecordList(params) {
  return request({
      url: '/alfmeier/findQuestRecordList',
      method: 'get',
      params,
  })
}
// 导出问卷记录
export function exportQuestRecord(params) {
  return request({
      url: '/alfmeier/exportQuestRecord',
      method: 'get',
      params,
  })
}

// 创建广告
export function createAdvertise(data) {
  return request({
      url: '/alfmeier/createAdvertise',
      method: 'post',
      data,
  })
}
// 修改广告
export function updateAdvertise(data) {
  return request({
      url: '/alfmeier/updateAdvertise',
      method: 'post',
      data,
  })
}
// 删除广告
export function removeAdvertise(data) {
  return request({
      url: '/alfmeier/removeAdvertise',
      method: 'post',
      data,
  })
}
// 获取单个广告
export function findAdvertise(params) {
  return request({
      url: '/alfmeier/findAdvertise',
      method: 'get',
      params,
  })
}
// 获取广告列表
export function findAdvertiseList(params) {
  return request({
      url: '/alfmeier/findAdvertiseList',
      method: 'get',
      params,
  })
}
// 导出广告
export function exportAdvertise(params) {
  return request({
      url: '/alfmeier/exportAdvertise',
      method: 'get',
      params,
  })
}
// 删除广告观看记录
export function removeAdvertiseRecord(data) {
  return request({
      url: '/alfmeier/removeAdvertiseRecord',
      method: 'post',
      data,
  })
}
// 获取单个广告记录
export function findAdvertiseRecord(params) {
  return request({
      url: '/alfmeier/findAdvertiseRecord',
      method: 'get',
      params,
  })
}
// 获取广告记录列表
export function findAdvertiseRecordList(params) {
  return request({
      url: '/alfmeier/findAdvertiseRecordList',
      method: 'get',
      params,
  })
}
// 导出广告记录
export function exportAdvertiseRecord(params) {
  return request({
      url: '/alfmeier/exportAdvertiseRecord',
      method: 'get',
      params,
  })
}

// 创建设备
export function createDevice(data) {
  return request({
      url: '/alfmeier/createDevice',
      method: 'post',
      data,
  })
}
// 修改设备
export function updateDevice(data) {
  return request({
      url: '/alfmeier/updateDevice',
      method: 'post',
      data,
  })
}
// 删除设备
export function removeDevice(data) {
  return request({
      url: '/alfmeier/removeDevice',
      method: 'post',
      data,
  })
}
// 获取单个设备
export function findDevice(params) {
  return request({
      url: '/alfmeier/findDevice',
      method: 'get',
      params,
  })
}
// 获取设备列表
export function findDeviceList(params) {
  return request({
      url: '/alfmeier/findDeviceList',
      method: 'get',
      params,
  })
}
// 导出设备
export function exportDevice(params) {
  return request({
      url: '/alfmeier/exportDevice',
      method: 'get',
      params,
  })
}
// 删除设备使用记录
export function removeDeviceRecord(data) {
  return request({
      url: '/alfmeier/removeDeviceRecord',
      method: 'post',
      data,
  })
}
// 获取单个设备使用记录
export function findDeviceRecord(params) {
  return request({
      url: '/alfmeier/findDeviceRecord',
      method: 'get',
      params,
  })
}
// 获取设备使用记录列表
export function findDeviceRecordList(params) {
  return request({
      url: '/alfmeier/findDeviceRecordList',
      method: 'get',
      params,
  })
}
// 导出设备使用记录
export function exportDeviceRecord(params) {
  return request({
      url: '/alfmeier/exportDeviceRecord',
      method: 'get',
      params,
  })
}
// 获取单个设备使用记录
export function findDeviceLog(params) {
  return request({
      url: '/alfmeier/findDeviceLog',
      method: 'get',
      params,
  })
}
// 获取设备使用记录列表
export function findDeviceLogList(params) {
  return request({
      url: '/alfmeier/findDeviceLogList',
      method: 'get',
      params,
  })
}
// 导出设备使用记录
export function exportDeviceLog(params) {
  return request({
      url: '/alfmeier/exportDeviceLog',
      method: 'get',
      params,
  })
}
